/** Cambia recomendaciones del mega menú Catálogo al pasar o enfocar cada categoría. */
if (!window.__catalogRecommendationsBound) {
  window.__catalogRecommendationsBound = true;

  const showRecommendations = (trigger) => {
    const target = trigger.dataset.recommendationTarget;
    const menu = trigger.closest('.mega-menu__grid');
    if (!target || !menu) return;

    const panels = menu.querySelectorAll('[data-recommendation-panel]');
    const selected = menu.querySelector(`[data-recommendation-panel="${CSS.escape(target)}"]`);
    if (!selected) return;

    panels.forEach((panel) => {
      panel.hidden = panel !== selected;
    });
  };

  document.addEventListener('pointerover', (event) => {
    const trigger = event.target.closest('[data-recommendation-target]');
    if (trigger) showRecommendations(trigger);
  });

  document.addEventListener('focusin', (event) => {
    const trigger = event.target.closest('[data-recommendation-target]');
    if (trigger) showRecommendations(trigger);
  });
}